import { SET_PFS_PARAMS, CLEAR_PFS_PARAMS } from "./pfsParamsActionCreators";

const initialState = {};

const pfsParamsReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_PFS_PARAMS:
			return {
				...action.payload,
			};

		case CLEAR_PFS_PARAMS:
			return {};

		default:
			return state;
	}
};

export default pfsParamsReducer;
